a.notification.list = (function(){
	var my = {
		page:function(){
			a.page({tpl:'notification/list/page',data:{},ready:function(){
				my.loadList();
				// Bind actions
				$('#notifications a[data-action="mark-all-read"]').unbind('click').click(function(){
					my.markAllRead();
				});
				$('#notifications a[data-action="refresh"]').unbind('click').click(function(){
					my.loadList();
				});
			}});
		},
		loadList:function(){
			$.ajax({
				type:'GET',
				url:'/api/notification/list/',
				data:{
					token:localStorage.getItem('token'),
					accountname:localStorage.getItem('accountname')
				},
				dataType:'json',
				cache: false,
				success:function(result) {
					if (result.success) {
						tpl.run({
							tpl:'/tpl/notification/list/list.ejs?v='+v,
							data:result,
							cb:function(c){
								$('#notifications ul[data-area="notifications"]').empty().append(c).ready(function(){
									my.initList(result.list);
								});
							}
						});
					}
					else {
						tpl.run({
							tpl:'/tpl/shared/nohits.ejs?v='+v,
							data:{},
							cb:function(c){
								$('#notifications ul[data-area="notifications"]').empty().append(c).ready(function(){
									
								});
							}
						});
					}
				}
			}).done(function(){});
		},
		initList:function(list){
			// Bind link/cta click
			$('#notifications ul[data-area="notifications"] [data-action="link"]').unbind('click').click(function(){
				my.clickLink($(this).attr('data-nid'),list);
			});
			// Bind mark read
			$('#notifications ul[data-area="notifications"] [data-action="mark-read"]').unbind('click').click(function(){
				my.markRead($(this).attr('data-nid'));
			});
			// Bind delete
			$('#notifications ul[data-area="notifications"] [data-action="delete"]').unbind('click').click(function(){
				my.deleteMsg($(this).attr('data-nid'));
			});
		},
		clickLink:function(nid,list){
			var linkarray = list.filter(function(e){
				return e.id == nid;
			});
			if (linkarray[0].link) {
				if (linkarray[0].link.type=='popup') {

					

					//a.ac(linkarray[0].link.section+'/'+linkarray[0].link.id+'/');
				}
				else if (linkarray[0].link.type=='page') {



					//location.hash='/'+linkarray[0].link.section+'/'+linkarray[0].link.id+'/';
				}
			}
		},
		markRead:function(nid){
			var msgc = $('#notifications ul[data-area="notifications"]>li[data-nid="'+nid+'"]');
			msgc.removeClass('unread');
			$.ajax({
				type:'POST',
				url:'/api/notification/mark/read/',
				data:{
					nid:nid,
					token:localStorage.getItem('token'),
					accountname:localStorage.getItem('accountname')
				},
				dataType:'json',
				cache: false,
				success:function(result) {
					if (result.success) {
						// Nothing more to do
					}
					else {
						msgc.addClass('unread');
					}
				}
			}).done(function(){});
		},
		markAllRead:function(){
			var msgc = $('#notifications ul[data-area="notifications"]>li');
			msgc.removeClass('unread');
			$.ajax({
				type:'POST',
				url:'/api/notification/mark/read/',
				data:{
					token:localStorage.getItem('token'),
					accountname:localStorage.getItem('accountname')
				},
				dataType:'json',
				cache: false,
				success:function(result) {
					if (result.success) {

					}
					else {
						msgc.addClass('unread');
					}
				}
			}).done(function(){});
		},
		deleteMsg:function(nid){
			var msgc = $('#notifications ul[data-area="notifications"]>li[data-nid="'+nid+'"]');
			msgc.slideUp(200);
			$.ajax({
				type:'POST',
				url:'/api//notification/delete/',
				data:{
					nid:nid,
					token:localStorage.getItem('token'),
					accountname:localStorage.getItem('accountname')
				},
				dataType:'json',
				cache: false,
				success:function(result) {
					if (result.success) {
						msgc.remove();
					}
					else {
						msgc.slideDown(200);
					}
				}
			}).done(function(){});
		}
	}
	return my;
}());